import { Navigate } from 'react-router-dom';

/** Detail view disabled while Meetings module is under construction. */
export default function MeetingDetailPage() {
  return <Navigate to="/meetings" replace />;
}
